export default {
  // Sync
  SET_IS_LOCKED: "SET_IS_LOCKED",
  SET_IS_SYNC: "SET_IS_SYNC",
  SET_SYNCING: "SET_SYNCING",
  SET_SYNC_PROFILE: "SET_SYNC_PROFILE",
  SET_SYNC_POLICIES: "SET_SYNC_POLICIES",

  // System
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
  TOGGLE_LOADING: "TOGGLE_LOADING",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  SET_IS_MOBILE: "SET_IS_MOBILE",
  SET_IS_COLUMN: "SET_IS_COLUMN",
  SET_COLLAPSED: "SET_COLLAPSED",
  SET_RESP_COLLAPSED: "SET_RESP_COLLAPSED",
  SET_SERVER_TYPE: "SET_SERVER_TYPE",
  SET_IS_SCROLL_TO_TOP: "SET_IS_SCROLL_TO_TOP",

  // Auth
  SET_USER_INFO: "SET_USER_INFO",
  SET_FACTOR2: "SET_FACTOR2",
  SET_SIGN_IN_RELOAD: "SET_SIGN_IN_RELOAD",

  // Cipher
  SET_ALL_CIPHERS: "SET_ALL_CIPHERS",

  // Organization
  SET_ALL_ORGANIZATIONS: "SET_ALL_ORGANIZATIONS",

  // Folder
  SET_ALL_FOLDERS: "SET_ALL_FOLDERS",

  // Collection
  SET_ALL_COLLECTIONS: "SET_ALL_COLLECTIONS",

  // Share
  SET_MY_SHARES: "SET_MY_SHARES",
  SET_INVITATIONS: "SET_INVITATIONS",
  SET_SENDS: "SET_SENDS",

  // Enterprise
  SET_TEAMS: "SET_TEAMS",
  SET_CURRENT_ENTERPRISE: "SET_CURRENT_ENTERPRISE",

  // Service
  SET_IS_READY: "SET_IS_READY",
  SET_REQUIRE_PAIRING: "SET_REQUIRE_PAIRING",
  SET_IS_CONNECTED: "SET_IS_CONNECTED",
  SET_CLIENT_ID: "SET_CLIENT_ID",
  SET_CLIENT_TYPE: "SET_CLIENT_TYPE",
  SET_APPROVE_CODE: "SET_APPROVE_CODE",
  SET_PAIRING_CONFIRMED: "SET_PAIRING_CONFIRMED",
  SET_IS_TOUCH: "SET_IS_TOUCH",
  SET_IS_FINGERPRINT: "SET_IS_FINGERPRINT",
  SET_IS_DESKTOP_CONNECTED: "SET_IS_DESKTOP_CONNECTED",
  SET_CACHE_DATA: "SET_CACHE_DATA",

  // Notice
  SET_CONFIRM_MY_SHARE_VISIBLE: "SET_CONFIRM_MY_SHARE_VISIBLE"
}
